import { $, $$, onReady } from '../nth-ms26-core/js/env';

/*
 * Màn Giải đấu — mọi nút/tab tự dựng từ nội dung GS soạn trong assets/static/frame2.html.twig:
 *   .gd-mode-panel[data-mode]  → nút chế độ (3V3, Bang Chiến...); data-soon = ảnh Coming Soon
 *   .gd-pane[data-tab]         → tab mục bên phải (Tổng Quan, Thể Lệ...)
 *   .gd-subs > .gd-sub[data-tab] → tab con (Thể Lệ, Thưởng)
 *   .gd-cal li[data-date]      → lưới lịch tháng
 * Thêm/bớt chế độ, tab, ngày thi đấu chỉ cần sửa nội dung, không đụng JS.
 */
const WEEKDAYS = ['Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7', 'Chủ Nhật'];
let uid = 0;

const el = (tag, cls, text) => {
  const node = document.createElement(tag);
  if (cls) node.className = cls;
  if (text != null) node.textContent = text;
  return node;
};
const pad = (n) => String(n).padStart(2, '0');
const label = (node) => (node.getAttribute('data-tab') || '').trim();

// Dãy nút chọn 1 trong nhiều khối (dùng cho tab mục + tab con): bấm nút nào hiện khối đó
function bindTabs(bar, buttons, panes, onChange) {
  const select = (i, focus) => {
    buttons.forEach((b, j) => {
      const on = i === j;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', String(on));
      b.tabIndex = on ? 0 : -1;
      panes[j].hidden = !on;
    });
    if (focus) buttons[i].focus();
    if (onChange) onChange(i);
  };
  buttons.forEach((b, i) => {
    const id = `gd-${(uid += 1)}`;
    b.id = `${id}-tab`;
    b.type = 'button';
    b.setAttribute('role', 'tab');
    panes[i].id = panes[i].id || `${id}-pane`;
    panes[i].setAttribute('role', 'tabpanel');
    panes[i].setAttribute('aria-labelledby', b.id);
    b.setAttribute('aria-controls', panes[i].id);
    b.addEventListener('click', () => select(i));
  });
  // ←/→ chuyển tab bằng bàn phím (chuẩn WAI-ARIA tabs). Thanh tab mục được dựng lại mỗi lần đổi chế độ
  // → chỉ gắn listener 1 lần, đọc dãy nút hiện hành qua bar.gdTabs
  bar.gdTabs = { buttons, select };
  if (!bar.gdKeys) {
    bar.gdKeys = true;
    bar.addEventListener('keydown', (e) => {
      const map = { ArrowRight: 1, ArrowLeft: -1 };
      if (!(e.key in map)) return;
      const { buttons: list, select: go } = bar.gdTabs;
      const cur = list.findIndex((b) => b.classList.contains('is-active'));
      e.preventDefault();
      go((cur + map[e.key] + list.length) % list.length, true);
    });
  }
  return select;
}

// ── Lịch tháng ──────────────────────────────────────────────
function initCalendar(cal) {
  const events = $$('li[data-date]', cal)
    .map((li) => {
      const m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec((li.dataset.date || '').trim());
      if (!m) return null;
      return {
        y: +m[1], m: +m[2], d: +m[3],
        type: li.dataset.type === 'live' ? 'live' : 'event',
        time: (li.dataset.time || '').trim(),
        title: li.textContent.trim(),
      };
    })
    .filter(Boolean);
  const list = $('.gd-cal__events', cal);
  if (list) list.hidden = true;

  const key = (y, m) => y * 12 + (m - 1);
  const keys = events.map((e) => key(e.y, e.m));
  const now = new Date();
  const today = key(now.getFullYear(), now.getMonth() + 1);
  const min = keys.length ? Math.min(...keys) : today;
  const max = keys.length ? Math.max(...keys) : today;
  // mở đúng tháng đang diễn ra; giải đã xong → tháng cuối, chưa tới → tháng đầu
  let cur = Math.min(max, Math.max(min, today));

  const head = el('div', 'gd-cal__head');
  const title = el('p', 'gd-cal__title');
  const legend = el('ul', 'gd-cal__legend');
  legend.append(el('li', 'gd-cal__key gd-cal__key--event', 'Sự kiện'), el('li', 'gd-cal__key gd-cal__key--live', 'Thi đấu trực tiếp'));
  const nav = el('div', 'gd-cal__nav');
  const prev = el('button', 'gd-cal__arrow gd-cal__arrow--prev');
  const next = el('button', 'gd-cal__arrow gd-cal__arrow--next');
  const month = el('span', 'gd-cal__month');
  prev.type = 'button';
  next.type = 'button';
  prev.setAttribute('aria-label', 'Tháng trước');
  next.setAttribute('aria-label', 'Tháng sau');
  month.setAttribute('aria-live', 'polite');
  nav.append(prev, month, next);
  head.append(title, legend, nav);

  const box = el('div', 'gd-cal__box');
  const week = el('div', 'gd-cal__week');
  WEEKDAYS.forEach((w, i) => {
    const s = el('span', null, w);
    if (i === 6) s.setAttribute('data-short', 'CN');
    week.appendChild(s);
  });
  const grid = el('div', 'gd-cal__grid');
  box.append(week, grid);
  cal.append(head, box);

  const render = () => {
    const y = Math.floor(cur / 12);
    const m = (cur % 12) + 1;
    title.textContent = `Tháng ${pad(m)}/${y}`;
    month.textContent = `${pad(m)}/${y}`;
    prev.disabled = cur <= min;
    next.disabled = cur >= max;

    const first = new Date(y, m - 1, 1);
    const lead = (first.getDay() + 6) % 7; // tuần bắt đầu Thứ 2
    const days = new Date(y, m, 0).getDate();
    const weeks = Math.ceil((lead + days) / 7);
    grid.style.setProperty('--weeks', weeks);
    grid.textContent = '';
    for (let i = 0; i < weeks * 7; i += 1) {
      const date = new Date(y, m - 1, i - lead + 1);
      const inMonth = date.getMonth() === m - 1;
      const cell = el('div', 'gd-day');
      cell.appendChild(el('span', 'gd-day__num', date.getDate()));
      if (!inMonth) cell.classList.add('is-out');
      const dayEvents = inMonth ? events.filter((e) => e.y === y && e.m === m && e.d === date.getDate()) : [];
      if (dayEvents.length) {
        // cùng ngày vừa sự kiện vừa thi đấu → ưu tiên hiện thi đấu trực tiếp
        const ev = dayEvents.find((e) => e.type === 'live') || dayEvents[0];
        cell.classList.add(`is-${ev.type}`);
        if (ev.type === 'live') {
          cell.appendChild(el('span', 'gd-day__live', 'LIVE'));
          cell.appendChild(el('span', 'gd-day__title', ev.title));
          if (ev.time) {
            const t = el('span', 'gd-day__time', ev.time);
            t.appendChild(el('span', 'gd-day__suffix', ' Bắt đầu'));
            cell.appendChild(t);
          }
        } else {
          cell.appendChild(el('span', 'gd-day__label')).appendChild(el('span', null, ev.title));
        }
        cell.setAttribute('title', dayEvents.map((e) => [e.title, e.time].filter(Boolean).join(' – ')).join('\n'));
      }
      grid.appendChild(cell);
    }
  };
  prev.addEventListener('click', () => { if (cur > min) { cur -= 1; render(); } });
  next.addEventListener('click', () => { if (cur < max) { cur += 1; render(); } });
  render();
}

onReady(() => {
  const root = $('[data-gd]');
  if (!root) return;
  const modeBar = $('[data-gd-modes]', root);
  const tabBar = $('[data-gd-tabs]', root);
  const panels = $$('.gd-mode-panel', root);
  if (!panels.length) return;

  // nội dung dài hơn khung → lăn chuột cuộn bên trong trước rồi mới chuyển màn (fullpage.js đọc data-scrollable)
  $$('.gd-pane', root).forEach((p) => p.setAttribute('data-scrollable', ''));

  // tab con: dựng 1 lần cho mỗi khối .gd-subs
  $$('.gd-subs', root).forEach((wrap) => {
    const subs = $$(':scope > .gd-sub', wrap);
    if (!subs.length) return;
    const bar = el('div', 'gd-subtabs');
    bar.setAttribute('role', 'tablist');
    const buttons = subs.map((s) => bar.appendChild(el('button', 'gd-subtab', label(s))));
    wrap.insertBefore(bar, subs[0]);
    bindTabs(bar, buttons, subs)(0);
  });
  $$('[data-gd-cal]', root).forEach(initCalendar);

  // FAQ 2 cột chảy dọc như PSD (câu 1-3 cột trái, 4-6 cột phải); câu cuối mỗi cột không có kẻ dưới
  $$('.gd-faq', root).forEach((faq) => {
    const items = $$(':scope > .gd-faq__item', faq);
    const rows = Math.ceil(items.length / 2);
    faq.style.setProperty('--rows', rows);
    items.forEach((it, i) => it.classList.toggle('is-col-end', i === rows - 1 || i === items.length - 1));
  });

  // mỗi chế độ nhớ tab đang xem để quay lại đúng chỗ
  const lastTab = new Map();
  let selectTab = null;

  const showMode = (i) => {
    const panel = panels[i];
    panels.forEach((p, j) => { p.hidden = i !== j; });
    modeButtons.forEach((b, j) => {
      b.classList.toggle('is-active', i === j);
      b.setAttribute('aria-selected', String(i === j));
      b.tabIndex = i === j ? 0 : -1;
    });
    const soon = panel.hasAttribute('data-soon');
    root.classList.toggle('is-soon', soon);
    tabBar.textContent = '';
    selectTab = null;
    if (soon) return;
    const panes = $$(':scope > .gd-pane', panel);
    const buttons = panes.map((p) => tabBar.appendChild(el('button', 'gd-tab', label(p))));
    selectTab = bindTabs(tabBar, buttons, panes, (t) => lastTab.set(panel, t));
    selectTab(lastTab.get(panel) || 0);
  };

  const modeButtons = panels.map((panel, i) => {
    const b = modeBar.appendChild(el('button', 'gd-mode'));
    b.type = 'button';
    b.setAttribute('role', 'tab');
    const icon = (panel.dataset.icon || '').trim();
    if (icon) b.appendChild(el('i', `gd-mode__ico gd-mode__ico--${icon}`)).setAttribute('aria-hidden', 'true');
    b.appendChild(el('span', null, (panel.dataset.mode || `Chế độ ${i + 1}`).trim()));
    b.addEventListener('click', () => showMode(i));
    return b;
  });
  modeBar.addEventListener('keydown', (e) => {
    const map = { ArrowRight: 1, ArrowLeft: -1 };
    if (!(e.key in map)) return;
    e.preventDefault();
    const cur = modeButtons.findIndex((b) => b.classList.contains('is-active'));
    const n = (cur + map[e.key] + panels.length) % panels.length;
    showMode(n);
    modeButtons[n].focus();
  });

  // nút "Xem thể lệ"... → mở tab theo tên trong data-gd-goto
  root.addEventListener('click', (e) => {
    const go = e.target.closest('[data-gd-goto]');
    if (!go || !selectTab) return;
    const panel = go.closest('.gd-mode-panel');
    const want = go.getAttribute('data-gd-goto').trim().toLowerCase();
    const idx = $$(':scope > .gd-pane', panel).findIndex((p) => label(p).toLowerCase() === want);
    if (idx > -1) selectTab(idx); // không đẩy focus sang tab (tránh hiện viền focus khi bấm chuột)
  });

  const def = panels.findIndex((p) => p.hasAttribute('data-default'));
  showMode(def > -1 ? def : 0);
});
